/**
 * 营销中心
 * @Description: 营销中心模块路由及完整子路由
 *
 * @Author: JZT.lmy
 * @Date: 2019-02-20 11:37:21
 * @Last Modified by: JZT.lmy
 * @Last Modified time: 2019-02-20 15:47:23
 */
export default [

    {
        path: "/marketing/rebate",
        name: "满减促销",
        component: () => import("@/pages/marketing/rebate"),
        icon: "none",
        meta: {
            comName: "rebateList",
            needRefresh: true
        }
    },
    {
        path: "/marketing/rebate/add",
        name: "新建满减促销",
        component: () => import("@/pages/marketing/rebate/rebateAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "rebateAdd"
        }
    },
    {
        path: "/marketing/rebate/edit",
        name: "编辑满减促销",
        component: () => import("@/pages/marketing/rebate/rebateEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "rebateEdit"
        }
    },
    {
        path: "/marketing/rebate/det",
        name: "查看满减促销",
        component: () => import("@/pages/marketing/rebate/rebateDet"),
        icon: "none",
        invisible: true,
        meta: {
            keepAlive: false,
            comName: "rebateDet"
        }
    },
    {
        path: "/marketing/coupon",
        name: "店铺优惠券",
        component: () => import("@/pages/marketing/coupon"),
        icon: "none",
        meta: {
            comName: "couponList",
            needRefresh: true
        }
    },
    {
        path: "/marketing/coupon/add",
        name: "新建店铺优惠券",
        component: () => import("@/pages/marketing/coupon/couponAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "couponAdd"
        }
    },
    {
        path: "/marketing/coupon/edit",
        name: "编辑店铺优惠券",
        component: () => import("@/pages/marketing/coupon/couponEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "couponEdit"
        }
    },
    {
        path: "/marketing/coupon/det",
        name: "查看店铺优惠券",
        component: () => import("@/pages/marketing/coupon/couponDet"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "couponDet"
        }
    },
    {
        path: "/marketing/coupon/stats",
        name: "优惠券统计",
        component: () => import("@/pages/marketing/coupon/couponStats"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "couponStats",
            needRefresh: true
        }
    }, {
        path: "/marketing/sitecoupon",
        name: "平台优惠券",
        component: () => import("@/pages/marketing/coupon/SiteCoupon"),
        icon: "none",
        meta: {
            comName: "SiteCouponList",
            needRefresh: true
        }
    },
    {
        path: "/marketing/sitecoupon/add",
        name: "新建平台优惠券",
        component: () => import("@/pages/marketing/coupon/SiteCouponAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "SitecouponAdd"
        }
    },
    {
        path: "/marketing/sitecoupon/edit",
        name: "编辑平台优惠券",
        component: () => import("@/pages/marketing/coupon/SiteCouponEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "SitecouponEdit"
        }
    },
    {
        path: "/marketing/sitecoupon/det",
        name: "查看平台优惠券",
        component: () => import("@/pages/marketing/coupon/SiteCouponDet"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "SitecouponDet"
        }
    },
    {
        path: "/marketing/group",
        name: "套餐促销",
        component: () => import("@/pages/marketing/group"),
        icon: "none",
        meta: {
            comName: "groupList",
            needRefresh: true
        }
    },
    {
        path: "/marketing/group/add",
        name: "新建套餐促销",
        component: () => import("@/pages/marketing/group/groupAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "groupAdd"
        }
    },
    {
        path: "/marketing/group/edit",
        name: "编辑套餐促销",
        component: () => import("@/pages/marketing/group/groupEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "groupEdit"
        }
    },

    {
        path: "/marketing/group/det",
        name: "查看套餐促销",
        component: () => import("@/pages/marketing/group/groupDet"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "groupDet"
        }
    },

    {
        path: "/marketing/seckill",
        name: "秒杀",
        component: () => import("@/pages/marketing/seckill/index"),
        icon: "none",
        meta: {
            comName: "seckillList",
            needRefresh: true
        }
    },
    {
        path: "/marketing/seckill/edit",
        name: "编辑秒杀",
        component: () => import("@/pages/marketing/seckill/seckillEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "seckillEdit"
        }
    },
    {
        path: "/marketing/seckill/add",
        name: "新增秒杀",
        component: () => import("@/pages/marketing/seckill/seckillAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "seckillAdd"
        }
    },
    {
        path: "/marketing/seckill/det",
        name: "查看秒杀",
        component: () => import("@/pages/marketing/seckill/seckillDet"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "seckillDet"
        }
    },
    {
        path: "/marketing/invite",
        name: "邀请有礼",
        component: () => import("@/pages/marketing/invite/inviteList"),
        icon: "none",
        meta: {
            comName: "inviteList",
            needRefresh: true
        }
    },
    {
        path: "/marketing/invite/edit",
        name: "编辑邀请有礼活动",
        component: () => import("@/pages/marketing/invite/inviteEdit"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "inviteEdit"
        }
    },
    {
        path: "/marketing/invite/det",
        name: "查看邀请有礼活动",
        component: () => import("@/pages/marketing/invite/inviteDet"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "inviteDet"
        }
    },
    {
        path: "/marketing/invite/add",
        name: "新增邀请有礼活动",
        component: () => import("@/pages/marketing/invite/inviteAdd"),
        icon: "none",
        invisible: true,
        meta: {
            comName: "inviteAdd"
        }
    },
    {
        path: "/marketing/invite/stats",
        name: "邀请数据统计",
        component: () => import("@/pages/marketing/invite/inviteStats"),
        icon: "none",
        meta: {
            comName: "inviteStats",
            needRefresh: true
        }
    },
    {
        path: '/marketing/preferentialPurchase',
        name: '超值换购',
        component: () => import('@/pages/marketing/preferentialPurchase'),
        icon: 'none',
        meta: {
            comName: 'preferentialPurchase',
            needRefresh: true
        }
    },
    {
        path: '/marketing/preferentialPurchase/update',
        name: '超值换购活动',
        component: () => import('@/pages/marketing/preferentialPurchase/activityUpdate'),
        icon: 'none',
        invisible: true,
        meta: {
            comName: 'preferentialPurchase'
        }
    }
];



// WEBPACK FOOTER //
// ./src/router/marketing.js